import type { AllRouteEndpoints } from "../routeTypes";
export const engagementEmailTemplatesDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/email_templates/:id",
  "/engagement/email_templates",
  "/engagement/email_draganddrop_templates/:id",
  "/engagement/email_draganddrop_templates",
];
